import TymberSite from "../models/tymberSite";

export default function makeSite(siteObject, settingsObject, groupSettings, themeObject) {
  if (siteObject && !siteObject.group_name) siteObject.group_name = null;
  return new TymberSite(siteObject, settingsObject, groupSettings, themeObject);
}
